import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto py-24 px-6 text-center">
        <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="text-4xl font-black tracking-tighter mb-4">Pagamento annullato</h1>
        <p className="text-slate-600 mb-8">Nessun importo è stato addebitato. Puoi riprovare quando vuoi.</p>
        <Link to="/pricing"><Button className="rounded-none bg-[#002FA7] hover:bg-[#001d6b] label-mono py-6 px-8">Torna al listino</Button></Link>
      </div>
    </Layout>
  );
}
